import baseUrl from "../config/baseUrl";

const addEmailTemplateData = async ({
  token,
  userId,
  isAdmin,
  name,
  description,
  type,
  language,
  subject,
  body_html,
  status
}) => {
  const formData = new FormData();
  formData.append("userId", userId);
  formData.append("isAdmin", isAdmin);
  formData.append("name", name || "");
  formData.append("description", description || "");
  formData.append("type", type || "");
  formData.append("language", language || "");
  formData.append("subject", subject || "");
  formData.append("body_html", body_html || "");
  formData.append("status", status || "active");

  try {
    const response = await fetch(`${baseUrl}/api/add-email-template-data`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    });
    const data = await response.json();
    return data;
  } catch (error) {
    return error;
  }
};

export default addEmailTemplateData;
